import { formatDateServer } from './formatDate'
import {
  lastFiscalWeekRange,
  lastsMonthRange,
  thisFiscalWeekRange,
  thisMonthRange,
} from './helpers'

export const PERIODS = {
  lastFiscalWeek: {
    from: formatDateServer(lastFiscalWeekRange[0]),
    to: formatDateServer(lastFiscalWeekRange[1]),
  },
  thisFiscalWeek: {
    from: formatDateServer(thisFiscalWeekRange[0]),
    to: formatDateServer(thisFiscalWeekRange[1]),
  },
  lastMonth: {
    from: formatDateServer(lastsMonthRange[0]),
    to: formatDateServer(lastsMonthRange[1]),
  },
  thisMonth: {
    from: formatDateServer(thisMonthRange[0]),
    to: formatDateServer(thisMonthRange[1]),
  },
}
